export default __webpack_public_path__ + "static/media/star.7f3531f6.svg";